import authModule from "./modules/auth";
import devicesModule from "./modules/devices";
import configurationModule from "./modules/configuration";
import reportingModule from "./modules/reporting";
import customerModule from "./modules/customer";

const actions = {
    changeLanguage: () => {
        customerModule.actions.reset();
    }
}

const store = {
    authModule,
    devicesModule,
    configurationModule,
    reportingModule,
    customerModule,

    actions
};


export default store;